<template>
  <div id="suspended-account">
    <div v-if="!needHelp">
      <p class="alert alert-danger">Your account is inactive. Reactivate your account to continue further.</p>
      <div class="action-btns">
        <button id="needHelp" type="button" class="btn btn-sm btn-link" @click="showNeedHelp">Need Help?</button>
        <button id="reactivate" type="button" class="btn btn-sm btn-primary" @click="reactivateUser">Reactivate</button>
      </div>
    </div>

    <inquiry-form v-if="needHelp" id="need-help" @close-inquiry="closeNeedHelp" />

    <modal v-model="reactivateUserModal" effect="fade">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Alert</strong></div>
      <p>
        A request to reactivate your account has been submitted. <br />
        Once status has been determined, an email will be sent to the registered email on file.
      </p>
      <div slot="modal-footer" class="modal-footer">
        <button id="ok" type="button" class="btn btn-sm btn-primary" @click="reactivateUserModal = false">OK</button>
      </div>
    </modal>

    <!-- notification failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>

    <spinner
      v-model="spinner.show"
      :global="spinner.isGlobal"
      :size="spinner.size"
      :fixed="spinner.fixed"
      :text="spinner.spinnerText"
    />
  </div>
</template>
<script>
import inquiryForm from "@/mycfm/components/InquiryForm";
import { reactivateUser } from "@/services/endpointsService";
import modal from "build-ui-x/src/Modal";
import spinner from "build-ui-x/src/Spinner";
import { mapState } from "vuex";

export default {
  components: {
    inquiryForm,
    modal,
    spinner
  },
  data() {
    return {
      spinner: {
        fixed: false,
        isGlobal: false,
        show: false,
        size: "md",
        spinnerText: ""
      },
      needHelp: false,
      registrationFailed: false,
      reactivateUserModal: false,
      resetPasswordURL: "https://mypassword.ge.com/fp/forgetPassword.xhtml",
      additionalAccessURL:
        "https://helpcenter.geaerospace.com/PortalsFAQ/s/article/How-to-request-additional-access-to-widgets-links"
    };
  },
  computed: {
    ...mapState("user", ["user"])
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      window.location.reload();
    },
    showNeedHelp() {
      this.needHelp = true;
    },
    closeNeedHelp() {
      this.needHelp = false;
    },
    reactivateUser() {
      this.spinner.show = true;
      reactivateUser(this.user.email)
        .then(data => {
          if (data.success) {
            this.reactivateUserModal = true;
          }
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.spinner.show = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
#suspended-account {
  margin-top: 25px;
}
</style>
